import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MpnMapping, MpnMappingResponse, UpdateMpnMappingRequest } from '@models/csp/mpn-mapping.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class MpnMappingsService {
  private readonly url = `${environment.bffUrl}/csp/mpn-mappings`;
  constructor(private httpClient: HttpClient) {}

  getAll(): Observable<MpnMapping[]> {
    return this.httpClient.get<MpnMappingResponse[]>(this.url);
  }

  update(mpnId: string, body: UpdateMpnMappingRequest): Observable<MpnMapping> {
    return this.httpClient.put<MpnMappingResponse>(`${this.url}/${mpnId}`, body);
  }

  delete(mpnId: string): Observable<void> {
    return this.httpClient.delete<void>(`${this.url}/${mpnId}`);
  }
}
